/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'
import {FormattedHTMLMessage, FormattedMessage, injectIntl} from 'react-intl'
import connect from "react-redux/es/connect/connect"
import {withRouter} from "react-router"
import {bindActionCreators} from "redux"
import * as UserActions from './UserActions'
import {Button, Card, Checkbox, Grid, Input, InputLabel, List, Modal, Notification, Select} from '@scuf/common'
import Loader from '../../common/Loader'
import {userHasActivity} from '../../security/SecurityUtils'
import {ACTIVITY_TYPES, ROLES} from "../../security/SecurityConst";
import {getBreadcrumbItemsAdminUser} from "../../utils/Helpers";
import BreadCrumb from '../../common/Bradcrumb'
import {userModel} from "../../model/User";
import {Routes} from "../../utils/Routes";
import {showNotification} from "../../common/ToastNotification";
import {toast} from "react-toastify";
import TreeSelector from "../../common/TreeSelector";
import {formatMessage} from "../../common/LocaleHelper";
import ErrorTitle from "../../faults/FaultDetail";
import LoosingDataModal from "../../common/LoosingDataModal";

class UserDetail extends React.Component {
    constructor(props) {
        super(props)

        const {profile, intl, match: { params }} = this.props

        const isCreatePage = isNaN(params.userId)

        this.state = {
            readAccess: !userHasActivity(profile, [ACTIVITY_TYPES.USERS_WRITE]),
            errorPaths: [],
            errors: [],
            model: userModel(intl, isCreatePage),
            create: isCreatePage,
            password: '',
            confirmPassword: '',
            confirmOpen: false,
            formIsDirty: true,
            closeLoosingDataModal: false,
            pathName: '',
        }

        this.setUserAttribute = this.setUserAttribute.bind(this)
        this.fetchRoles = this.fetchRoles.bind(this)
        this.submitUser = this.submitUser.bind(this)
        this.getErrorMessage = this.getErrorMessage.bind(this)
        this.assignRole = this.assignRole.bind(this)
        this.assignFleet = this.assignFleet.bind(this)
        this.passwordPanel = this.passwordPanel.bind(this)
        this.deactivateUser = this.deactivateUser.bind(this)
        this.reactivateUser = this.reactivateUser.bind(this)
        this.deactivateUserConfirm = this.deactivateUserConfirm.bind(this)
        this.fetchAssignedUnresolvedFaults = this.fetchAssignedUnresolvedFaults.bind(this)
        this.renderDeactivateButton = this.renderDeactivateButton.bind(this)
        this.renderReactivateButton = this.renderReactivateButton.bind(this)
    }

    componentDidMount() {
        const {profile} = this.props
        this.fetchUser()
        this.fetchRoles()
        if (!userHasActivity(profile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)) {
            this.fetchFleets()
        }

        this.unblock = this.props.history.block( (a) => {
            if (this.state.formIsDirty) {
                this.setState({closeLoosingDataModal: true, pathName: a})
            }
            return !this.state.formIsDirty;
        })
    }

    componentWillUnmount() {
        this.unblock()
    }

    fetchUser() {
        const { match: { params } } = this.props;
        if (isNaN(params.userId)) {
            this.props.UserActions.clearState()
        } else {
            this.props.UserActions.fetchUser(params.userId)
        }
    }

    fetchRoles() {
        this.props.UserActions.fetchRoles()
    }

    fetchFleets() {
        this.props.UserActions.fetchFleetsHierarchy()
    }

    setUserAttribute(key, value) {
        this.props.UserActions.setUserAttribute(key, value)
    }

    getRoleOptions() {
        const {roles} = this.props
        return roles.map(role => {
            return {key: role.id, value: role.id, text: role.name}
        })
    }

    getFleetHierarchyOptions() {
        const {fleetsHierarchy} = this.props
        return fleetsHierarchy.map(f => {
            return this.getHierarchyItem(f)
        })
    }

    getHierarchyItem(item) {
        let subItems = []
        if (item.subFleets && item.subFleets.length > 0) {
            subItems = item.subFleets.map(f => {
                return this.getHierarchyItem(f)
            })
        }
        return {
            id: item.id,
            name: item.name,
            selectable: true,
            items: subItems,
        }
    }

    submitUser() {
        const {user, profile} = this.props

        const {model, create} = this.state
        const passwordNonEmpty = !!(this.state.password && this.state.password.trim()) || !!(this.state.confirmPassword && this.state.confirmPassword.trim())

        const hdaRoles = profile.roles.filter(r => r.name === ROLES.HDA_MECHANIC || r.name === ROLES.HDA_ADMIN)

        if (hdaRoles.length > 0) {
            user.roles.forEach(r => r.fleets = hdaRoles[0].fleets)
        }

        if (create || passwordNonEmpty) {
            //add password to user object
            user.password = this.state.password
            user.confirmPassword = this.state.confirmPassword
        }
        user.userName = user.userName.trim()
        model.validate(user, {abortEarly: false})
            .then(() => {
                this.setState({errorPaths: [], errors: [], formIsDirty: false})
                //remove confirm password
                user.confirmPassword = null

                if (user.id) {
                    return this.props.UserActions.updateUser(user).then((response) => {
                        this.props.history.push(Routes.USERS);
                        this.showNotification(response, "user.schema.user.updated.successfully");
                        return (response);
                    }).catch((err) => {
                        if(err.generalError === false) {
                            showNotification({
                                translationPropertyKey: err.errorKey,
                                severity: "critical",
                            });
                        }
                    })
                } else {
                    return this.props.UserActions.createUser(user).then((response) => {
                        this.props.history.push(Routes.USERS);
                        this.showNotification(response, "user.schema.user.added.successfully");
                        return (response);
                    }).catch((err) => {
                        if (err.generalError === false) {
                            showNotification({
                                translationPropertyKey: err.errorKey,
                                severity: "critical",
                            });
                        }
                    })
                }

            }) //called if the entire form is valid
            .catch(err => {
                if (err.inner && err.inner.map) {
                    this.setState({
                        errors: err.errors, errorPaths: err.inner.map(i => {
                            return {path: i.path, message: i.errors}
                        }),
                    })
                }
                user.password = null
                user.confirmPassword = null
            }) //called if any field is invalid
    }

    deactivateUserConfirm() {
        this.setState({confirmOpen: true})
        this.fetchAssignedUnresolvedFaults()
    }

    deactivateUser() {
        const {user, history} = this.props

        this.props.UserActions.deactivateUser(user.id).then(() => {
            this.setState({formIsDirty: false});
            history.push(Routes.USERS)
            showNotification({
                translationPropertyKey: 'admin.user.edit.deactivation.success',
                severity: "success",
            })
        }).catch(() => {
            this.setState({confirmOpen: false})
        })
    }

    reactivateUser() {
        const {user, history} = this.props

        this.props.UserActions.reactivateUser(user.id).then(() => {
            this.setState({formIsDirty: false});
            history.push(Routes.USERS)
            showNotification({
                translationPropertyKey: 'admin.user.edit.reactivation.success',
                severity: "success",
            })
        })
    }

    showNotification(response, text) {
        const toastId = showNotification({
            translationPropertyKey: text,
            autoClose: 3000,
            onDetailsClick: () => {
                toast.dismiss(toastId.toastId);
                this.props.history.push(Routes.USERS + "/" + response['id']);
            },
            onClose: () => {},

        });

    }

    assignRole(id, index) {
        const {roles} = this.props
        //find role object
        const newRole = roles.find(role => role.id === id)
        this.props.UserActions.setRole(index, newRole)
    }

    findItem(id, items) {
        for (const item of items) {
            if (item.id === id) {
                return item
            } else if (item.subFleets) {
                const findedItem = this.findItem(id, item.subFleets)
                if (findedItem) {
                    return findedItem
                }
            } else {
                // Continue searching
            }
        }
    }

    assignFleet(value, role) {
        const fleets = []
        //find fleets objects
        value.forEach(fleetId => {
            fleets.push(this.findItem(fleetId, this.props.fleetsHierarchy))
        })

        this.props.UserActions.setFleet(fleets, role)
    }

    fetchAssignedUnresolvedFaults() {
        const {user} = this.props

        const states = ['NEW', 'IN_PROGRESS', 'VERIFICATION', 'ON_HOLD'];
        const assignee = user.id;
        const search = null;
        const sort = null;
        const ids = null;
        this.props.UserActions.requestFaults(states, search, sort, ids, assignee);
    }

    roleCards() {
        const {user, intl} = this.props

        return (
            <React.Fragment>
                <Modal size="small" closeIcon={true} open={this.state.confirmOpen} onClose={() => this.setState({confirmOpen: false})} closeOnDimmerClick={false}>
                    <Modal.Header>
                        <FormattedMessage id="admin.user.edit.deactivate.modal.header" />
                    </Modal.Header>
                    <Modal.Content>
                        <div>
                            <Notification
                                hasIcon={this.props.faults.length > 0}
                                severity={this.props.faults.length > 0 ? 'important' : 'information'}>
                                <FormattedHTMLMessage id="admin.user.edit.deactivate.modal.description" values={{displayName: user.displayName, faultsCount: this.props.faults.length}} />
                            </Notification>
                        </div>
                    </Modal.Content>
                    <Modal.Footer>
                        <Button type="secondary" size="medium" content={intl.formatMessage({id: 'admin.user.edit.cancel'})} onClick={() => this.setState({confirmOpen: false})}/>
                        <Button type="primary" size="medium" content={intl.formatMessage({id: 'admin.user.edit.deactivate'})} onClick={this.deactivateUser}/>
                    </Modal.Footer>
                </Modal>

                {
                    user.roles.map((role, index)  => {
                            return this.getRoleCard(role, index)
                        }
                    )}
            </React.Fragment>
        )
    }

    getRoleActivities(role) {
        return role.activities.map( activity => {
            return (
                <List.Content key={activity.id}>
                    {activity.description}
                </List.Content>
            )
        })
    }

    getErrorMessage(fields) {
        const errs = []
        fields.forEach(field =>   errs.push(this.state.errorPaths.find(err => err.path === field)))

        return errs.filter(err => err !== undefined).reduce(
            (composeMsg, err) => composeMsg ? composeMsg + "<br/>" + err.message : err.message, null)
    }

    generalDataPanel() {
        const {user, intl} = this.props

        return (
            <Card>
                <Card.Header title={intl.formatMessage({id: "admin.user.edit.panel.general"})}>
                    <div className="right">
                        {this.renderDeactivateButton()}
                        {this.renderReactivateButton()}
                    </div>
                </Card.Header>
                <Card.Content>
                    <Grid>
                        {
                            user.externalUser ?
                                <Grid.Row>
                                    <Grid.Column>
                                        <div>
                                            <Notification
                                                hasIcon={true}
                                                severity="information">
                                                <FormattedMessage id="admin.user.ssoUser"/>
                                            </Notification>
                                        </div>
                                    </Grid.Column>
                                </Grid.Row>
                                :
                                null
                        }
                        <Grid.Row>
                            <Grid.Column width={3} sWidth={12}>
                                <Input placeholder={intl.formatMessage({id: "admin.user.edit.userName"})}
                                       label={intl.formatMessage({id: "admin.user.edit.userName"})+' *'}
                                       value={user.userName}
                                       onChange={value => {this.setUserAttribute('userName', value);}}
                                       fluid
                                       disabled={!this.state.create}
                                       error={this.getErrorMessage(['userName'])}
                                />
                            </Grid.Column>
                            <Grid.Column width={3} sWidth={12}>
                                <Input placeholder={intl.formatMessage({id: "admin.user.edit.email"})}
                                       label={intl.formatMessage({id: "admin.user.edit.email"})+' *'}
                                       value={user.email}
                                       onChange={value => this.setUserAttribute('email', value)}
                                       fluid
                                       disabled={this.state.readAccess || user.status !== 'ACTIVE'}
                                       error={this.getErrorMessage(['email'])}
                                />
                            </Grid.Column>
                            <Grid.Column width={3} sWidth={12}>
                                <div className="email-checkBox">
                                    <Checkbox
                                        label={intl.formatMessage({id: 'admin.users.edit.email.notification'})}
                                        toggle={true}
                                        checked={user.emailNotification === 'ACTIVE'}
                                        disabled={this.state.readAccess || user.status !== 'ACTIVE'}
                                        onChange={() => {this.setUserAttribute('emailNotification', user.emailNotification === 'ACTIVE' ? 'DISABLED' : 'ACTIVE')}}
                                    />
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={3} sWidth={12}>
                                <Input placeholder={intl.formatMessage({id: "admin.user.edit.firstName"})}
                                       label={intl.formatMessage({id: "admin.user.edit.firstName"})+' *'}
                                       value={user.firstName}
                                       onChange={value => this.setUserAttribute('firstName', value)}
                                       fluid
                                       disabled={this.state.readAccess || user.status !== 'ACTIVE' || user.externalUser}
                                       error={this.getErrorMessage(['firstName'])}
                                />

                            </Grid.Column>
                            <Grid.Column width={3} sWidth={12}>
                                <Input placeholder={intl.formatMessage({id: "admin.user.edit.middleName"})}
                                       label={intl.formatMessage({id: "admin.user.edit.middleName"})}
                                       value={user.middleName}
                                       onChange={value => this.setUserAttribute('middleName', value ? value.trim() : value)}
                                       fluid
                                       disabled={this.state.readAccess || user.status !== 'ACTIVE' || user.externalUser}
                                       error={this.getErrorMessage(['middleName'])}
                                />

                            </Grid.Column>
                            <Grid.Column width={3} sWidth={12}>
                                <Input placeholder={intl.formatMessage({id: "admin.user.edit.lastName"})}
                                       label={intl.formatMessage({id: "admin.user.edit.lastName"})+' *'}
                                       value={user.lastName}
                                       onChange={value => this.setUserAttribute('lastName', value)}
                                       fluid
                                       disabled={this.state.readAccess || user.status !== 'ACTIVE' || user.externalUser}
                                       error={this.getErrorMessage(['lastName'])}
                                />

                            </Grid.Column>

                        </Grid.Row>
                    </Grid>
                </Card.Content>
            </Card>
        )
    }

    renderDeactivateButton() {
        const {user, intl} = this.props
        const {create} = this.state

        if(create || user.status !== 'ACTIVE') {
            return null;
        }

        return (
            <Button
                type="secondary"
                content={intl.formatMessage({id: "admin.user.edit.deactivate"})}
                disabled={this.state.readAccess}
                onClick={this.deactivateUserConfirm}
                className="top-button-space"
            />
        )
    }

    renderReactivateButton() {
        const {user, intl} = this.props
        const {create} = this.state

        if(create || user.status !== 'DISABLED') {
            return null;
        }

        return (
            <Button
                type="secondary"
                content={intl.formatMessage({id: "admin.user.edit.reactivate"})}
                disabled={this.state.readAccess}
                onClick={this.reactivateUser}
                className="top-button-space"
            />
        )
    }

    rolesPanel() {
        const {intl} = this.props

        return (
            <Card >
                <Card.Header title={intl.formatMessage({id: "admin.user.edit.panel.roles"})} />
                <Card.Content>
                    <Grid >
                        {this.roleCards()}
                    </Grid>
                </Card.Content>
            </Card>
        )
    }

    getRoleCard(role, index) {
        const {intl, profile, user} = this.props

        let roleValue = null
        if (role.id) {
            roleValue = role.id
        }
        let fleetValue = []
        if (role.fleets && role.fleets.length > 0) {
            fleetValue = role.fleets.map(fleet => fleet.id)
        }
        const rolesIndexStr = 'roles[' + index +']'

        return (
            <React.Fragment key={role.id}>

                <Grid.Row>
                    {
                        userHasActivity(profile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) ?
                            null
                            :
                            <Grid.Column width={3} sWidth={12}>
                                <div>
                                    <InputLabel label={intl.formatMessage({id:"admin.user.edit.fleet"})+' *'}/>
                                    <TreeSelector
                                        placeholder={intl.formatMessage({id:"admin.user.edit.fleet.select"})}
                                        singleSelection={false}
                                        subtreeSelection={true}
                                        selectionChanged={(id) => this.assignFleet(id, role)}
                                        tree={this.getFleetHierarchyOptions()}
                                        selectedItems={fleetValue}
                                        error={this.getErrorMessage([rolesIndexStr + '.fleets'])}
                                        disabled={this.state.readAccess || user.status !== 'ACTIVE'}
                                    />
                                </div>
                            </Grid.Column>
                    }

                    <Grid.Column width={3} sWidth={12}>
                        <div>
                            <InputLabel label={intl.formatMessage({id:"admin.user.edit.role"})+' *'}/>
                            <Select
                                fluid
                                options={this.getRoleOptions()}
                                placeholder={intl.formatMessage({id: "admin.user.edit.role.select"})}
                                value={roleValue}
                                disabled={this.state.readAccess || user.status !== 'ACTIVE'}
                                onChange={(id) => this.assignRole(id, index)}
                                error={this.getErrorMessage(['roles',rolesIndexStr + '.id'])}
                            />
                        </div>
                    </Grid.Column>
                    <Grid.Column width={4} sWidth={12}>
                        <div>
                            <InputLabel label={intl.formatMessage({id:"admin.user.edit.activities"})}/>
                            <Card fluid className={'activity-card'}>
                                <Card.Content>
                                    <List>
                                        {this.getRoleActivities(role)}
                                    </List>
                                </Card.Content>
                            </Card>
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </React.Fragment>
        )
    }

    passwordPanel() {
        const {user, intl} = this.props

        return (
            <Card>
                <Card.Header title={intl.formatMessage({id: "admin.user.edit.panel.security"})} />
                <input style={{display:'none'}} type="text" name="fakeusernameremembered" autoComplete="new-password"/>
                <input style={{display:'none'}} type="password" name="fakepasswordremembered" autoComplete="new-password"/>
                <Card.Content>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={3} sWidth={12}>
                                <Input placeholder={intl.formatMessage({id: "admin.user.edit.password"})}
                                       label={intl.formatMessage({id: "admin.user.edit.password"})+' *'}
                                       type="password"
                                       value={this.state.password}
                                       onChange={value => this.setState({password:  value})}
                                       fluid
                                       disabled={this.state.readAccess || user.status !== 'ACTIVE'}
                                       error={this.getErrorMessage(['password'])}
                                />
                            </Grid.Column>
                            <Grid.Column width={3} sWidth={12}>
                                <Input placeholder={intl.formatMessage({id: "admin.user.edit.password.confirm"})}
                                       label={intl.formatMessage({id: "admin.user.edit.password.confirm"})+' *'}
                                       type="password"
                                       value={this.state.confirmPassword}
                                       onChange={value => this.setState({confirmPassword:  value})}
                                       fluid
                                       disabled={this.state.readAccess || user.status !== 'ACTIVE'}
                                       error={this.getErrorMessage(['confirmPassword'])}
                                />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Card.Content>
            </Card>
        )
    }

    translateBreadCrumbs(breadCrumbs) {
        const {intl} = this.props

        return breadCrumbs.map((b, index, arr) => {
            return { url: b.url, name: b.name.length > 0 && index < arr.length -1 ? intl.formatMessage({id: b.name}) : b.name}
        })
    }

    render() {
        const {intl, user, loading, error} = this.props

        if (error) {
            return <ErrorTitle title={"user.detail.error."+error} />
        }

        const breadCrumbs = this.translateBreadCrumbs(getBreadcrumbItemsAdminUser(intl, user))

        return (
            <React.Fragment>
                <LoosingDataModal
                    open={this.state.closeLoosingDataModal}
                    onClose={() => {this.setState({closeLoosingDataModal: false})}}
                    onContinue={() => {
                        this.setState({formIsDirty: false, closeLoosingDataModal: false}, () => {
                            this.props.history.push(this.state.pathName)
                        })
                    }
                    }
                />
                <Loader loading={loading}/>
                <BreadCrumb items={breadCrumbs}/>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            {this.generalDataPanel()}
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column width={12}>
                            {this.rolesPanel()}
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column width={12}>
                            {user.externalUser ? null : this.passwordPanel()}
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column width={12}>
                            <div className="cancel-save-button-div">
                                <Button
                                    type="secondary"
                                    content={intl.formatMessage({id: "admin.user.edit.cancel"})}
                                    onClick={() => this.props.history.push(Routes.USERS)}
                                    className="cancel-save-delete-button mobile-max-width-button"
                                />
                                <Button
                                    type="primary"
                                    content={intl.formatMessage({id: "admin.user.edit.save"})}
                                    disabled={this.state.readAccess || user.status !== 'ACTIVE'}
                                    onClick={this.submitUser}
                                    className="cancel-save-delete-button mobile-max-width-button"
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.user,
        loading: state.user.loading,
        profile: !state.security ? null : state.security.userProfile,
        roles: state.user.roles,
        fleetsHierarchy: state.user.fleetsHierarchy,
        faults: state.user.faults,
        error: state.user.error,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        UserActions: bindActionCreators(UserActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(UserDetail)))